export default "__VITE_PUBLIC_ASSET__4daafba3__"